/**
 * Composant d'historique des contacts
 */

import { Mail, FileText, RefreshCw, Clock, Phone, MessageSquare } from 'lucide-react';

const ICON_CONFIG = {
  email: { icon: Mail, bg: 'bg-blue-100', color: 'text-blue-600' },
  devis: { icon: FileText, bg: 'bg-green-100', color: 'text-green-600' },
  changement_statut: { icon: RefreshCw, bg: 'bg-purple-100', color: 'text-purple-600' },
  appel: { icon: Phone, bg: 'bg-amber-100', color: 'text-amber-600' },
  note: { icon: MessageSquare, bg: 'bg-cyan-100', color: 'text-cyan-600' },
  default: { icon: Clock, bg: 'bg-slate-100', color: 'text-slate-600' }
};

export const HistoriqueItem = ({ entry }) => {
  const config = ICON_CONFIG[entry.type] || ICON_CONFIG.default;
  const Icon = config.icon;

  return (
    <div className="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
      <div className={`h-8 w-8 rounded-full flex items-center justify-center flex-shrink-0 ${config.bg}`}>
        <Icon className={`h-4 w-4 ${config.color}`} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-slate-700">{entry.notes || entry.message}</p>
        <p className="text-xs text-slate-400 mt-1">
          {new Date(entry.date).toLocaleString('fr-FR')}
          {entry.auteur && <span> • {entry.auteur}</span>}
        </p>
      </div>
    </div>
  );
};

export const HistoriqueList = ({ 
  historique = [], 
  maxItems, 
  emptyMessage = "Aucun historique",
  className = ""
}) => {
  if (!historique || historique.length === 0) {
    return (
      <p className="text-sm text-slate-400 p-4 bg-slate-50 rounded-lg text-center">
        {emptyMessage}
      </p>
    );
  }

  // Afficher les éléments les plus récents en premier
  const sortedHistorique = [...historique].reverse();
  const displayedItems = maxItems ? sortedHistorique.slice(0, maxItems) : sortedHistorique;

  return (
    <div className={`space-y-2 ${className}`}>
      {displayedItems.map((entry, idx) => (
        <HistoriqueItem key={entry.id || idx} entry={entry} />
      ))}
      {maxItems && historique.length > maxItems && (
        <p className="text-xs text-center text-slate-400 pt-2">
          + {historique.length - maxItems} autres entrées
        </p>
      )}
    </div>
  );
};

export default HistoriqueList;
